<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>markunread_mailbox</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Autorización de Comprobantes Fiscales Pendientes</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.sucursalId"
              :items="sucursales"
              item-text="nombre"
              item-value="id"
              label="Originadas en:"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <app-selector-periodos
              v-on:update-periodo="filtro.periodo = $event"
              :column="true"
            ></app-selector-periodos>
          </v-col>
          <v-col cols="3">
            <v-btn color="success" @click="getItems(true)">Consultar</v-btn>
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-card-title>
              Cantidad de Comprobantes a Autorizar
            </v-card-title>
            <v-card-text>
              <div>Facturas: {{ cantidadFacturas }}</div>
              <div>Notas de Crédito: {{ cantidadNotasCredito }}</div>
              <div>Notas de Débito: {{ cantidadNotasDebito }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row dense align="center">
            <v-col>
              <v-btn
                v-if="records.length > 0"
                @click.stop="solicitarAutorizacionAfip()"
                color="brown"
                dark
              >
                Solicitar Autorización AFIP</v-btn
              >
              &nbsp;
            </v-col>
            <v-col>
              <!-- <v-checkbox v-if="records.length>0" v-model="modificarFechaAHoy" label="Modificar fecha de Comprobante Hoy"></v-checkbox> -->
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- Resultados Autorizacion Afip  -->
    <v-dialog
      v-model="showResultadosAutorizacion"
      width="1000"
      v-if="showResultadosAutorizacion"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Resultados Autorización</v-card-title>
        <v-card-text>
          <v-row v-if="autorizando">
            <div>
              Autorizando Comprobante {{ currentItem + 1 }} de {{ totalItems }}
            </div>
          </v-row>
          <v-row v-if="autorizando">
            <div>
              {{ records.find((r) => r.id == comprobanteActual.id).tipo }} a
              {{
                records.find((r) => r.id == comprobanteActual.id).personaNombre
              }}
              por
              {{
                records.find((r) => r.id == comprobanteActual.id).importe
                  | currency
              }}
            </div>
          </v-row>

          <v-row v-if="!autorizando">
            <div>PROCESO FINALIZADO</div>
          </v-row>

          <v-row dense>
            <v-data-table
              dense
              :headers="headers"
              :items="resultadosAutorizacion"
              :rows-per-page="pagination.rowsPerPage"
              :options.sync="pagination"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="!primeraBusquedaRealizada"
                  :value="true"
                  color="grey lighten-3"
                  icon="info"
                >
                  Ingrese los filtros para realizar la búsqueda
                </v-alert>
                <v-alert v-else :value="true" color="grey" icon="warning">
                  No se encontraron datos
                </v-alert>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.comprobante }}</td>
                  <td class="text-xs-left caption">{{ item.resultado }}</td>
                  <td class="text-xs-left caption" v-if="item.elapsed > 1000">
                    <v-chip x-small dark color="red">{{ item.elapsed }}</v-chip>
                  </td>
                  <td class="text-xs-left caption" v-else>
                    <v-chip x-small dark color="green">{{
                      item.elapsed
                    }}</v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="autorizando"
            @click="cancelarAutorizacion = true"
            color="red"
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!autorizando"
            @click="
              showResultadosAutorizacion = false;
              getItems(true);
            "
            color="green"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-loading :loading="componentsLoading || loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  components: {},
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 20, 50, 100, 500, 1000],
      },
      headers: [
        // definición de columnas
        { text: 'Comprobante', value: 'comprobante' },
        { text: 'Resultado', value: 'resultado' },
        { text: 'Tiempo (ms)', value: 'elapsed' },
      ],
      totalItems: 0, // va afuera de pagination
      records: [], // registros
      filtro: {
        empresaId: 0,
        sucursalId: 0,
        tipoComprobanteId: 0,
        cui: 0,
        periodo: { id: 1 },
        soloPendientesAutorizacion: false,
      },
      empresas: [],
      sucursales: [],
      listTiposComprobante: [],
      showResultadosAutorizacion: false,
      resultadosAutorizacion: [],
      autorizando: false,
      modificarFechaAHoy: false,
      comprobanteActual: null,
      currentItem: 0,
      cancelarAutorizacion: false,
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
    activeTask: function() {
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if (this.closeRelatedTasks) {
        this.showDetalle = false;
        this.getItems(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    componentsLoading: function() {
      return (
        this.loadingCreditosEnMora ||
        this.loadingTelefonos ||
        this.loadingGestionesTelefonicas ||
        this.loadingOtrasGestiones
      );
    },
    cantidadFacturas: function() {
      if (!this.records) return 0;
      return this.records.filter((r) => r.tipo == 'Factura Venta').length;
    },
    cantidadNotasCredito: function() {
      if (!this.records) return 0;
      return this.records.filter((r) => r.tipo == 'Nota Crédito').length;
    },
    cantidadNotasDebito: function() {
      if (!this.records) return 0;
      return this.records.filter((r) => r.tipo == 'Nota Débito').length;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (!this.filtro.empresaId || this.filtro.empresaId == 0) {
        this.alertError('Por favor, seleccione la Empresa');
        return;
      }

      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      filter.cui = filter.cui ? filter.cui : 0;

      let incluirNotasCredito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 1;
      let incluirNotasDebito =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 2;
      let incluirFacturasVenta =
        filter.tipoComprobanteId == 0 || filter.tipoComprobanteId == 3;

      try {
        var result = await http.get(
          'comprobantes/listcomprobantesfiscales?empresaId=' +
            filter.empresaId +
            '&sucursalId=' +
            filter.sucursalId +
            '&incluirNotasCredito=true&incluirNotasDebito=true&incluirFacturasVenta=true&documento=0&limit=99999&page=1' +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&soloPendientesAutorizacion=true'
        );

        Vue.$log.debug(result);

        this.records = result.list;

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async solicitarAutorizacionAfip() {
      try {
        this.autorizando = true;
        this.showResultadosAutorizacion = true;
        this.cancelarAutorizacion = false;

        var listaComprobantes = [];
        for (let i = 0; i < this.records.length; i++) {
          const comprobante = this.records[i];

          listaComprobantes.push({
            id: comprobante.id,
            tipo: comprobante.tipo,
          });
        }

        this.resultadosAutorizacion = [];

        for (let i = 0; i < listaComprobantes.length; i++) {
          this.comprobanteActual = listaComprobantes[i];
          this.currentItem = i;

          try {
            var startTime = new Date();
            var res = await http.post(
              'comprobantes/autorizarcomprobantefiscal',
              JSON.stringify({
                comprobanteId: this.comprobanteActual.id,
                tipo: this.comprobanteActual.tipo,
              })
            );
            var endTime = new Date();

            if (res.autorizado) {
              this.resultadosAutorizacion.unshift({
                comprobante: res.comprobanteDescripcion,
                resultado: ': Autorizado con Número' + res.numero,
                elapsed: endTime - startTime,
              });
            } else {
              this.resultadosAutorizacion.unshift({
                comprobante: res.comprobanteDescripcion,
                resultado: ': ERROR ' + res.errores,
                elapsed: endTime - startTime,
              });
            }
          } catch (error) {
            // error durante el llamado, registro y sigo
            this.resultadosAutorizacion.unshift({
              comprobante:
                ' Tipo: ' +
                this.comprobanteActual.tipo +
                'Id' +
                this.comprobanteActual.id,
              resultado: ': ERROR ' + error,
              elapsed: endTime - startTime,
            });
          }

          if (this.cancelarAutorizacion) {
            break;
          }
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.autorizando = false;
    },
    imprimir() {
      let params = [];

      var listaIds = '';

      for (let i = 0; i < this.selectedRow.length; i++) {
        const item = this.selectedRow[i];
        if (listaIds != '') listaIds = listaIds + ',';
        listaIds = listaIds + item.id;
      }

      params.push({
        ListaIds: listaIds,
      });

      this.setReporteActivo({
        reporte: 'ComprobanteVentaElectronico.trdp',
        params: params,
      });
      window.open('/report-viewer');
    },
  },
};
</script>
